import { createSelector } from 'reselect';
import {
    MERCHANT_DETAILS_LOAD,
    MERCHANT_DETAILS_SUCCESS,
    MERCHANT_DETAILS_FAILURE,
    UPDATE_PENDING_LIST_ITEM_LOAD,
    UPDATE_PENDING_LIST_ITEM_SUCCESS,
    UPDATE_PENDING_LIST_ITEM_FAILURE,
    GET_PENDING_LIST_UPLOAD_LINKS_LOAD,
    GET_PENDING_LIST_UPLOAD_LINKS_SUCCESS,
    GET_PENDING_LIST_UPLOAD_LINKS_FAILURE,
    SUBMIT_PENDING_LIST_LOAD,
    SUBMIT_PENDING_LIST_SUCCESS,
    SUBMIT_PENDING_LIST_FAILURE,
    DELETE_PENDING_LIST_DOCUMENT_LOAD,
    DELETE_PENDING_LIST_DOCUMENT_SUCCESS,
    DELETE_PENDING_LIST_DOCUMENT_FAILURE,
    GET_PENDING_LIST_DOWNLOAD_URLS_SUCCESS
} from './merchantDetailsActions';

const initialState = {
    merchantDetails: {},
    loading: false,
    error: null,
    updatePendingListItemLoading: false,
    updatePendingListItemError: null,
    getPendingListUploadLinksLoading: false,
    getPendingListUploadLinksError: null,
    uploadLinks: null,
    deletePendingListDocumentLoading: false,
    deletePendingListDocumentError: null,
    submitPendingListLoading: false,
    submitPendingListError: null,
    downloadUrls: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case MERCHANT_DETAILS_LOAD:
            return {
                ...state,
                loading: true,
                error: null
            };

        case MERCHANT_DETAILS_SUCCESS:
            return {
                ...state,
                merchantDetails: action.merchantDetails,
                loading: false,
                error: null
            };

        case MERCHANT_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case UPDATE_PENDING_LIST_ITEM_LOAD:
            return {
                ...state,
                updatePendingListItemLoading: true,
                updatePendingListItemError: null
            };

        case UPDATE_PENDING_LIST_ITEM_SUCCESS:
            return {
                ...state,
                updatePendingListItemLoading: false,
                updatePendingListItemError: null
            };

        case UPDATE_PENDING_LIST_ITEM_FAILURE:
            return {
                ...state,
                updatePendingListItemLoading: false,
                updatePendingListItemError: action.error
            };

        case GET_PENDING_LIST_UPLOAD_LINKS_LOAD:
            return {
                ...state,
                getPendingListUploadLinksLoading: true,
                getPendingListUploadLinksError: null,
                uploadLinks: null
            };

        case GET_PENDING_LIST_UPLOAD_LINKS_SUCCESS:
            return {
                ...state,
                getPendingListUploadLinksLoading: false,
                getPendingListUploadLinksError: null,
                uploadLinks: action.uploadLinks
            };

        case GET_PENDING_LIST_UPLOAD_LINKS_FAILURE:
            return {
                ...state,
                getPendingListUploadLinksLoading: false,
                getPendingListUploadLinksError: action.error,
                uploadLinks: null
            };

        case DELETE_PENDING_LIST_DOCUMENT_LOAD:
            return {
                ...state,
                deletePendingListDocumentLoading: true,
                deletePendingListDocumentError: null
            };

        case DELETE_PENDING_LIST_DOCUMENT_SUCCESS:
            return {
                ...state,
                deletePendingListDocumentLoading: false,
                deletePendingListDocumentError: null
            };

        case DELETE_PENDING_LIST_DOCUMENT_FAILURE:
            return {
                ...state,
                deletePendingListDocumentLoading: false,
                deletePendingListDocumentError: action.error
            };

        case SUBMIT_PENDING_LIST_LOAD:
            return {
                ...state,
                submitPendingListLoading: true,
                submitPendingListError: null
            };

        case SUBMIT_PENDING_LIST_SUCCESS:
            return {
                ...state,
                submitPendingListLoading: false,
                submitPendingListError: null
            };

        case SUBMIT_PENDING_LIST_FAILURE:
            return {
                ...state,
                submitPendingListLoading: false,
                submitPendingListError: action.error
            };

        case GET_PENDING_LIST_DOWNLOAD_URLS_SUCCESS:
            return {
                ...state,
                downloadUrls: {
                    ...state.downloadUrls,
                    [action.itemId]: action.downloadUrls
                }
            };

        default:
            return state;
    }
}

export const getMerchantDetailsEntity = (state) => state.entities.merchantDetails;

export const getMerchantDetails = createSelector(
    [getMerchantDetailsEntity],
    (merchantDetailsEntity) => merchantDetailsEntity.merchantDetails
);

export const getIsMerchantDetailsLoading = createSelector(
    [getMerchantDetailsEntity],
    (merchantDetailsEntity) => merchantDetailsEntity.loading
);

export const getMerchantDetailsErrorMessage = createSelector(
    [getMerchantDetailsEntity],
    (merchantDetailsEntity) => merchantDetailsEntity.error
);

export const getIsGetPendingListUploadLinksLoading = createSelector(
    [getMerchantDetailsEntity],
    (merchantDetailsEntity) => merchantDetailsEntity.getPendingListUploadLinksLoading
);

export const getGetPendingListUploadLinksError = createSelector(
    [getMerchantDetailsEntity],
    (merchantDetailsEntity) => merchantDetailsEntity.getPendingListUploadLinksError
);

export const getUploadLinks = createSelector(
    [getMerchantDetailsEntity],
    (merchantDetailsEntity) => merchantDetailsEntity.uploadLinks
);
